import { $GQL } from '@GQL/index';

export async function getArchivedLead(email: string) {
    const query = `
        query GetArchivedLead($email: String!) {
            archivedLead(email: $email) {
                id
                first_name
                last_name
                email
                city
                phone
                zip
                created_at
                db
                lead_data
            }
        }`;

    const result = await $GQL.request(query, { email });
    return result.archivedLead;
}